import React from 'react';

import { Switch as MuiSwitch } from '@material-ui/core';

import Tick from '../../icons/Tick';
import X from '../../icons/X';

export interface SwitchProps {
  checked?: boolean;
  disabled?: boolean;
}

export const Switch = (props: SwitchProps): JSX.Element => {
  const { checked = true, disabled = false } = props;

  return (
    <MuiSwitch
      checked={checked}
      checkedIcon={<Tick size="xs" />}
      color="default"
      disabled={disabled}
      icon={<X size="xs" />}
      inputProps={{ 'aria-label': 'checkbox' }}
    />
  );
};
